import axios from '../axiosConfig'
import i18n from '../lang/idiomas'
import { tokenConfig } from './auth'
import { createMessage } from './messages'

import {
  BORRAR_EXCEL_PEDIDO,
  CAMBIAR_CANTIDAD_ARTICULO,
  IMPORTAR_EXCEL_PEDIDO,
  IMPORTAR_EXCEL_PEDIDO_FAILURE,
  IMPORTAR_EXCEL_PEDIDO_SUCCESS,
} from './types'

export const importarLineasExcel = jsonData => (dispatch, getState) => {
  dispatch({
    type: IMPORTAR_EXCEL_PEDIDO,
  })
  let url = '/pedidos/importarLineasExcel/'

  let header = tokenConfig(getState)

  var jsonPedido = jsonData.map(item => {
    return {
      articulo: item.articulo,
      cantidad: item.cantidad || 0,
      rowNum: item.__rowNum__,
      validez: '',
      precio: '',
    }
  })

  axios
    .post(url, { jsonData: jsonPedido }, header)
    .then(respuesta => {
      dispatch({
        type: IMPORTAR_EXCEL_PEDIDO_SUCCESS,
        payload: respuesta.data,
      })
    })
    .catch(err => {
      console.log('Ha ocurrido un error al procesar el archivo')

      if (err.response.data.errores) {
        var mensaje = i18n.t('excel.erprocfi')
        err.response.data.errores.map(e => {
          return (mensaje += e + '\n')
        })
        dispatch(createMessage(mensaje, 'error'))
      } else if (err.response.status === 400) {
        dispatch(createMessage(i18n.t('excel.invforfi'), 'error'))
      }

      dispatch({
        type: IMPORTAR_EXCEL_PEDIDO_FAILURE,
      })
    })
}

export const cambiarCantidadArticulo = linea => (dispatch, getState) => {
  dispatch({
    type: CAMBIAR_CANTIDAD_ARTICULO,
    payload: linea,
  })
}

export const borrarLineasExcel = () => (dispatch, getState) => {
  dispatch({
    type: BORRAR_EXCEL_PEDIDO,
  })
}
